import type { Components, Theme } from "@mui/material";

export const MuiDialogContentText: Components<Theme>["MuiDialogContentText"] = {
  styleOverrides: {
    root: {
      lineHeight: 1.65,
    },
  },
};
